module.exports = __webpack_public_path__ + "img/offline_kiosk_02.png";